function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.93 18.727l-1.102 1.101a4 4 0 01-5.656-5.656l1.25-1.25m7.65-7.65l1.1-1.1a4 4 0 115.656 5.656l-1.5 1.5",
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 15h3M15 19v3M6 9H3M9 5V2",
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeLinecap: "round"
});

function SvgUnlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/unlink.svg";
export { SvgUnlink as ReactComponent };